import { RecurringOrderSettingsOrigin } from 'api/admin/orders/getRecurringOrder';

export const ORIGIN_DISPLAY = {
  [RecurringOrderSettingsOrigin.LIVE_LINK_ORDER_CREATION]: 'Live Link Order Creation',
  [RecurringOrderSettingsOrigin.LIVE_LINK_RECURRING_ORDER_MANAGER_PAGE]:
    'Live Link Recurring Order manager',
  [RecurringOrderSettingsOrigin.LIVE_LINK_ORDER_MANAGER_PAGE]: 'Live Link Manage order page',
  [RecurringOrderSettingsOrigin.STORE_CLOSURES_MANAGER]:
    'Business Manager Store closure conflicts manager',
  [RecurringOrderSettingsOrigin.STORE_DELIVERY_WINDOWS_MANAGER]:
    'Business Manager Delivery windows conflicts manager',
  [RecurringOrderSettingsOrigin.INHERITED_FROM_RECURRING_SUBSCRIPTION]:
    'Migration from Recurring Order v.1',
  [RecurringOrderSettingsOrigin.BUSINESS_MANAGER_CUSTOMER_PAGE]: 'Business Manager Customer Card',
  [RecurringOrderSettingsOrigin.BUSINESS_MANAGER_ORDER_PAGE]: 'Business Manager Order card',
};
